import { Box, CssBaseline } from "@mui/material";
import { AccountButton, AuthProvider, Navbar } from "@ssf/auth-components";
import {
  AppWrapper,
  Footer,
  Page,
  queryClient,
  sisTheme,
} from "@ssf/components";
import { QueryClientProvider } from "@tanstack/react-query";

import { Router } from "./components/index.js";
import { i18next, routes } from "./lib/index.js";

const SIGNIN_REDIRECT_ARGS = { extraQueryParams: { createAccount: true } };
const SIGNOUT_REDIRECT_ARGS = { state: { returnTo: routes.signedOut } };

export const App = () => (
  <AppWrapper env={import.meta.env} theme={sisTheme} i18n={i18next}>
    <CssBaseline />
    <QueryClientProvider client={queryClient}>
      <AuthProvider
        signinRedirectArgs={SIGNIN_REDIRECT_ARGS}
        signoutRedirectArgs={SIGNOUT_REDIRECT_ARGS}
      >
        <Page>
          <Navbar>
            <AccountButton />
          </Navbar>
          <Box sx={{ flex: "1 0 auto", position: "relative" }}>
            <Router />
          </Box>
          <Footer />
        </Page>
      </AuthProvider>
    </QueryClientProvider>
  </AppWrapper>
);
